import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from 'aos'
import ReactGA from 'react-ga';

import { Navbar, PageNotFound, Footer, PageLoader } from './components';
import {
  ProtectedRoutes, FacultyUpdate, FacultyProtectedRoutes, FacultyLogin, FacultyChangePassword, ClubLogin, ClubProtectedRoutes, ClubAllEvents,
  ClubUpdate, ClubChangePassword, EventAdd, EventUpdate, AddFacility, UpdateFacility, ViewFacility, AddAchievements, ViewAchievements, UpdateAchievements,
  AddAnnouncements, ViewAnnouncements, UpdateAnnouncements, ViewSyllabus, UpdateSyllabus, AddSyllabus, ViewToppers, AddToppers, UpdateToppers,
  AddTestimonials, UpdateTestimonials, ViewTestimonials, AddPlacementCarousel, ViewPlacementCarousel, UpdatePlacementCarousel, ViewGallery, UpdateGallery, AddGallery,
  AddLandingCarousel, ViewLandingCarousel, UpdateLandingCarousel, Dashboard, ViewProject, UpdateProject, AddProject, ClubRegister, ViewFaculty
}
  from './components';
import {
  AboutPage, LandingPage, PeoplePage, AcademicsPage, ActivitiesPage, ContactPage, PlacementsPage, ResourcesPage, Login, Profile, Register,
  ClubsPage, FacilitiesPage, ClubProfilePage, FacultyProfilePage, TeamPage, GalleryPage, AnnouncementPage, AdmissionPage
}
  from './pages';

import './App.css';


import ScrollToTop from "./utils/ScrollToTop"

import ForgotPassword from "./components/Admin/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/Admin/ForgotPassword/ResetPassword";
import ClubForgotPassword from "./components/Admin/ForgotPassword/Club/ClubForgotPassword";
import ClubResetPassword from "./components/Admin/ForgotPassword/Club/ClubResetPassword";
import FacultyResetPassword from "./components/Admin/ForgotPassword/Faculty/FacultyResetPassword";
import FacultyForgotPassword from "./components/Admin/ForgotPassword/Faculty/FacultyForgotPassword";
import ViewClubs from "./components/Admin/Clubs/ViewClubs";
import FacultyEdit from './components/Admin/Faculty/FacultyEdit';
import FacultyRegister from './components/Admin/Faculty/FacultyRegister/FacultyRegister';


const TRACKING_ID = "G-DZEG9M1ZR9"; 
ReactGA.initialize(TRACKING_ID);

function App() {

  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    setTimeout(() => setSpinner(false), 1500)
  }, []);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);


  AOS.init({
    duration: 800,
    once: true
  })

  return (
    <div className="app">
      {spinner ? (
        <PageLoader />
      ) : (
        <>
          <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="admission" element={<AdmissionPage />} />
              <Route path="people" element={<PeoplePage />} />
              <Route path="academics" element={<AcademicsPage />} />
              <Route path="activities" element={<ActivitiesPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="placements" element={<PlacementsPage />} />
              <Route path="facilities" element={<FacilitiesPage />} />
              <Route path="resources" element={<ResourcesPage />} />
              <Route path="resources" element={<ResourcesPage />} />
              <Route path="clubs/:id" element={<ClubProfilePage />} />
              <Route path="faculty/:id" element={<FacultyProfilePage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="gallery" element={<GalleryPage />} />
              <Route path="announcements" element={<AnnouncementPage />} />

              <Route path="*" element={<PageNotFound />} />

              {/* ------- ADMIN ROUTES ------ */}
              <Route path="admin-register" element={<Register />} />
              <Route path="admin-login" element={<Login />} />
              <Route path="admin/forgot-password" element={<ForgotPassword />} />
              <Route path="admin/reset-password/:id/:token" element={<ResetPassword />} />

              {/* ------- ADMIN AUTH ROUTES ------ */}
              <Route element={<ProtectedRoutes />}>

                {/*  DASHBOARD  */}
                <Route path='admin' element={<Dashboard />} />

                {/*  FACILTY  */}
                <Route path='admin/facility' element={<ViewFacility />} />
                <Route path='admin/facility/add' element={<AddFacility />} />
                <Route path='admin/facility/:id/update' element={<UpdateFacility />} />

                {/*  ACHIEVEMENTS  */}
                <Route path='admin/achievements' element={<ViewAchievements />} />
                <Route path='admin/achievements/add' element={<AddAchievements />} />
                <Route path='admin/achievements/:id/update' element={<UpdateAchievements />} />

                {/*  ANNOUNCEMENTS  */}
                <Route path='admin/announcements' element={<ViewAnnouncements />} />
                <Route path='admin/announcements/add' element={<AddAnnouncements />} />
                <Route path='admin/announcements/:id/update' element={<UpdateAnnouncements />} />

                {/*  SYLLABUS  */}
                <Route path='admin/syllabus' element={<ViewSyllabus />} />
                <Route path='admin/syllabus/add' element={<AddSyllabus />} />
                <Route path='admin/syllabus/:id/update' element={<UpdateSyllabus />} />

                {/*  TOPPERS  */}
                <Route path='admin/toppers' element={<ViewToppers />} />
                <Route path='admin/toppers/add' element={<AddToppers />} />
                <Route path='admin/toppers/:id/update' element={<UpdateToppers />} />

                {/*  TESTIMONIALS  */}
                <Route path='admin/testimonials' element={<ViewTestimonials />} />
                <Route path='admin/testimonials/add' element={<AddTestimonials />} />
                <Route path='admin/testimonials/:id/update' element={<UpdateTestimonials />} />

                {/*  GALLERY  */}
                <Route path='admin/gallery' element={<ViewGallery />} />
                <Route path='admin/gallery/add' element={<AddGallery />} />
                <Route path='admin/gallery/:id/update' element={<UpdateGallery />} />

                {/*  PROJECT  */}
                <Route path='admin/project' element={<ViewProject />} />
                <Route path='admin/project/add' element={<AddProject />} />
                <Route path='admin/project/:id/update' element={<UpdateProject />} />

                {/*  PLACEMENT CAROUSEL  */}
                <Route path='admin/placement-carousel' element={<ViewPlacementCarousel />} />
                <Route path='admin/placement-carousel/add' element={<AddPlacementCarousel />} />
                <Route path='admin/placement-carousel/:id/update' element={<UpdatePlacementCarousel />} />

                {/*  LANDING CAROUSEL  */}
                <Route path='admin/landing-carousel' element={<ViewLandingCarousel />} />
                <Route path='admin/landing-carousel/add' element={<AddLandingCarousel />} />
                <Route path='admin/landing-carousel/:id/update' element={<UpdateLandingCarousel />} />

                <Route path="admin-profile" element={<Profile />} />
                <Route path="admin-clubs" element={<ClubsPage />} />

                {/* FACULTY REGISTER  */}
                <Route path="admin/faculty/register" element={<FacultyRegister />} />
                <Route path="admin/faculty/:id/update" element={<FacultyEdit />} />

                {/* FACULTY */}
                <Route path="admin/faculty" element={<ViewFaculty />} />

                {/* CLUB REGISTER */}
                <Route path="admin/clubs/register" element={<ClubRegister />} />

                {/* CLUB REGISTER  */}
                <Route path="admin/clubs" element={<ViewClubs />} />

                {/* CLUB PASSWORD RESET  */}
                <Route path="admin/clubs/reset-password" element={<ClubForgotPassword />} />
                <Route path="admin/clubs/reset-password/:id/:club_token" element={<ClubResetPassword />} />

                {/* FACULTY PASSWORD RESET  */}
                <Route path="admin/faculty/reset-password" element={<FacultyForgotPassword />} />
                <Route path="admin/faculty/reset-password/:id/:faculty_token" element={<FacultyResetPassword />} />
              </Route>

              {/* ------- FACULTY AUTH ROUTES ------ */}
              <Route path="faculty/login" element={<FacultyLogin />} />

              <Route element={<FacultyProtectedRoutes />}>
                <Route path="faculty/:id/update" element={<FacultyUpdate />} />
                <Route path="faculty/:id/change-password" element={<FacultyChangePassword />} />
              </Route>

              {/* ------- CLUB AUTH ROUTES ------ */}
              <Route path="clubs/login" element={<ClubLogin />} />

              <Route element={<ClubProtectedRoutes />}>
                <Route path="clubs/:id/update" element={<ClubUpdate />} />
                <Route path="clubs/:id/change-password" element={<ClubChangePassword />} />
                <Route path="clubs/:id/add-event" element={<EventAdd />} />
                {/* <Route path="clubs/:id/edit-event" element={<EventAdd />} /> */}
                <Route path="clubs/:id/events" element={<ClubAllEvents />} />
                <Route path="clubs/:id/events/:eventid/update" element={<EventUpdate />} />
              </Route>
            </Routes>
            <Footer />
          </BrowserRouter>
        </>
      )}
    </div>
  );
}

export default App;
